import ThemeContext from "@casino/legacy/client/containers/shared/ThemeProvider/ThemeContext";
import { useContext } from "react";

const useThemeContext = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useThemeContext should be used within the ThemeContext");
  }

  return context;
};

export default useThemeContext;
